<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="mat-label-general me-10" [ngbTooltip]="additionalComp_tooltip" placement="right" container="body" tooltipClass="additional">
        <!-- Additional Component -->
        {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.ADDITIONAL_COMPONENTS' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #additionalComp_tooltip>
        <div>
            <ng-container *transloco="let t; read: 'TOOLTIP.INFORMATE_CALC_LABELS.ADDITIONAL_COMPONENT'">
                <p>{{ t('FIRST_PARAGRAPH') }}</p>
                <ul>
                    <li>{{ t('BULLET_POINT_POINT_1') }}</li>
                    <li>{{ t('BULLET_POINT_POINT_2') }}</li>
                </ul>
                <p>{{ t('SECOND_PARAGRAPH') }}</p>
            </ng-container>
        </div>
    </ng-template>
    <!--tool-tip template end-->
    <mat-checkbox class="mat-checkbox-general checkbox-wrap" name="component_check" formControlName="isAddnlOveride"></mat-checkbox>
    <br />
    <mat-select
        *ngIf="form.get('isAddnlOveride').value == false"
        class="mat-select-general input-form-class"
        formControlName="addnlThickness"
        name="addnlThickness"
        [class.spinner]="loading"
    >
        <mat-option class="option-list" value="0.00 mm"> None (0.00 mm)</mat-option>
        <mat-option class="option-list" *ngFor="let atl of additionalThicknessList" [value]="atl.additionalThicknessId">{{
            atl.name + ' (' + (atl.additionalThicknessValue | number: '1.2-2') + ' mm)'
        }}</mat-option>
    </mat-select>

    <input
        *ngIf="form.get('isAddnlOveride').value == true"
        matInput
        class="input-form-class mat-input-number"
        name="additional_input"
        formControlName="addnlOverideValue"
    />
</div>
